<template>
  <div :class="getFeedbackCardClass">
    <div class="feedback-card-title">
      <h4 class="feedback-title">Give Feedback</h4>
      <Button class="closeBtn" @click="closeFeedback(false)">
        <i class="vcore_icon icon-close"></i>
      </Button>
    </div>
    <p class="feedback-header">How was your experience using our application today?</p>
    <div class="feedback-card-button-grid">
      <button class="feedback-button" @mouseover="swapImage('poor', 'hover')" @mouseout="swapImage('poor', 'default')"
        @click="chooseFeedback('poor')" :disabled="this.selectedFeedback != ''">
        <img alt="Poor Feedback" :src="poorButtonSource" />
      </button>
      <button class="feedback-button" @mouseover="swapImage('okay', 'hover')" @mouseout="swapImage('okay', 'default')"
        @click="chooseFeedback('okay')" :disabled="this.selectedFeedback != ''">
        <img alt="Okay Feedback" :src="okayButtonSource" />
      </button>
      <button class="feedback-button" @mouseover="swapImage('good', 'hover')" @mouseout="swapImage('good', 'default')"
        @click="chooseFeedback('good')" :disabled="this.selectedFeedback != ''">
        <img alt="Good Feedback" :src="goodButtonSource" />
      </button>
    </div>
    <div :class="getExpandedSectionClass" id="feedback-expanded-section">
      <p class="feedback-bottom-text">Tell us more about your reasons for this rating</p>
      <textarea class="expanded-feedback" id="expanded-feedback" rows="4" v-model="expandedFeedback"
        maxlength="500"></textarea>
      <p class="character-count">{{ charactersLeft }} characters remaining</p>
      <label for="consent" class="cb-form-checkbox-label consent-checkbox">
        <input type="checkbox" id="consent" value="consent" class="cb-form-checkbox-input" v-model="consentToContact">
        <span class="cb-form-checkbox-indicator"></span>
        <span class="feedback-bottom-text">I consent to Commerce Bank contacting me about my feedback.</span>
      </label>
      <div>
        <p class="feedback-bottom-text">This form is not used for troubleshooting. If you need assistance, please
          contact the Commerce Bank Customer Care Center. </p>
      </div>
      <div>
        <button class="one-time-payment-primary-button send-feedback-button" @click="closeFeedback(true)">Send Feedback</button>
      </div>
    </div>
  </div>
</template>

<script>
	import DefaultPoor from "@Shared/assets/images/DefaultFeedbackPoor.png";
import DefaultOkay from "@Shared/assets/images/DefaultFeedbackOkay.png";
import DefaultGood from "@Shared/assets/images/DefaultFeedbackGood.png";
import HoverPoor from "@Shared/assets/images/HoverFeedbackPoor.png";
import HoverOkay from "@Shared/assets/images/HoverFeedbackOkay.png";
import HoverGood from "@Shared/assets/images/HoverFeedbackGood.png";
import SelectedPoor from "@Shared/assets/images/SelectedFeedbackPoor.png";
import SelectedOkay from "@Shared/assets/images/SelectedFeedbackOkay.png";
import SelectedGood from "@Shared/assets/images/SelectedFeedbackGood.png";
import DisabledPoor from "@Shared/assets/images/DisabledFeedbackPoor.png";
import DisabledOkay from "@Shared/assets/images/DisabledFeedbackOkay.png";
import DisabledGood from "@Shared/assets/images/DisabledFeedbackGood.png";
import MobileDefaultPoor from "@Shared/assets/images/MobileDefaultFeedbackPoor.png";
import MobileDefaultOkay from "@Shared/assets/images/MobileDefaultFeedbackOkay.png";
import MobileDefaultGood from "@Shared/assets/images/MobileDefaultFeedbackGood.png";
import MobileSelectedPoor from "@Shared/assets/images/MobileSelectedFeedbackPoor.png";
import MobileSelectedOkay from "@Shared/assets/images/MobileSelectedFeedbackOkay.png";
import MobileSelectedGood from "@Shared/assets/images/MobileSelectedFeedbackGood.png";
import MobileDisabledPoor from "@Shared/assets/images/MobileDisabledFeedbackPoor.png";
import MobileDisabledOkay from "@Shared/assets/images/MobileDisabledFeedbackOkay.png";
import MobileDisabledGood from "@Shared/assets/images/MobileDisabledFeedbackGood.png";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Feedback",
  data() {
    return {
      poorButtonSource: DefaultPoor,
      okayButtonSource: DefaultOkay,
      goodButtonSource: DefaultGood,
      selectedFeedback: "",
      expandedFeedback: "",
      consentToContact: false,
      feedbackID: 0,
      feedbackData: {}
    };
  },
  computed: {
    ...mapGetters(["showFeedbackModal", "selfEnrollmentID", "getFeedbackDetails"]),
    getExpandedSectionClass() {
      return this.selectedFeedback == "" ? "hidden" : "feedback-expanded-section"
    },
    getFeedbackCardClass() {
      if (this.showFeedbackModal) {
        return this.selectedFeedback == "" ? "feedback-card" : "feedback-card expanded";
      }
      return "hidden";
    },
    charactersLeft() {
      return 500 - this.expandedFeedback.length;
    },
    mobileView() {
      return window.innerWidth < 577
    }
  },
  methods: {
    ...mapActions(["setShowFeedbackModal", "saveFeedback"]),
    swapImage(button, state) {
      if (this.selectedFeedback == "") {
        switch (button) {
          case "poor":
            switch (state) {
              case "default":
                this.poorButtonSource = this.mobileView ? MobileDefaultPoor : DefaultPoor;
                break;
              case "hover":
                this.poorButtonSource = HoverPoor;
                break;
              case "selected":
                this.poorButtonSource = this.mobileView ? MobileSelectedPoor : SelectedPoor;
                this.okayButtonSource = this.mobileView ? MobileDisabledOkay : DisabledOkay;
                this.goodButtonSource = this.mobileView ? MobileDisabledGood : DisabledGood;
                break;
            }
            break;
          case "okay":
            switch (state) {
              case "default":
                this.okayButtonSource = this.mobileView ? MobileDefaultOkay : DefaultOkay;
                break;
              case "hover":
                this.okayButtonSource = HoverOkay;
                break;
              case "selected":
                this.okayButtonSource = this.mobileView ? MobileSelectedOkay : SelectedOkay;
                this.poorButtonSource = this.mobileView ? MobileDisabledPoor : DisabledPoor;
                this.goodButtonSource = this.mobileView ? MobileDisabledGood : DisabledGood;
                break;
            }
            break;
          case "good":
            switch (state) {
              case "default":
                this.goodButtonSource = this.mobileView ? MobileDefaultGood : DefaultGood;
                break;
              case "hover":
                this.goodButtonSource = HoverGood;
                break;
              case "selected":
                this.goodButtonSource = this.mobileView ? MobileSelectedGood : SelectedGood;
                this.poorButtonSource = this.mobileView ? MobileDisabledPoor : DisabledPoor;
                this.okayButtonSource = this.mobileView ? MobileDisabledOkay : DisabledOkay;
                break;
            }
            break;
        }
      }
    },
    chooseFeedback(feedback) {
      if (this.selectedFeedback == "") {
        switch (feedback) {
          case "poor":
            this.swapImage("poor", "selected");
            this.selectedFeedback = "poor";
            break;
          case "okay":
            this.swapImage("okay", "selected");
            this.selectedFeedback = "okay";
            break;
          case "good":
            this.swapImage("good", "selected");
            this.selectedFeedback = "good";
            break;
        }
        this.submitFeedback(false);
      }
    },
    async submitFeedback(sendConsent) {
      let feedbackTypeID = 0;
      const userAgent = navigator.userAgent;

      switch (this.selectedFeedback) {
        case "poor":
          feedbackTypeID = 1;
          break;
        case "okay":
          feedbackTypeID = 2;
          break;
        case "good":
          feedbackTypeID = 3;
          break;
      }

      this.feedbackData = {
        FeedbackID: this.feedbackID,
        SelfEnrollmentID: this.selfEnrollmentID,
        Page: location.href,
        ConsentToContact: sendConsent ? this.consentToContact : false,
        FeedbackTypeID: feedbackTypeID,
        FeedbackText: this.expandedFeedback,
        UserAgent: userAgent,
      }
      this.feedbackID = await this.saveFeedback(this.feedbackData)
    },
    closeFeedback(sendConsent) {
      this.setShowFeedbackModal(false);

      if (this.expandedFeedback != "" || (this.consentToContact && sendConsent)) {
        this.submitFeedback(sendConsent)
      }
    }
  },
  mounted() {
    this.feedbackData = this.getFeedbackDetails;
    if (window.innerWidth < 577) {
      this.poorButtonSource = MobileDefaultPoor;
      this.okayButtonSource = MobileDefaultOkay;
      this.goodButtonSource = MobileDefaultGood;
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 35px;
  gap: 20px;

  position: absolute;

  background: #FFFFFF;
  border: 1px solid #EAEDF0;
  box-shadow: 0px 14px 50px rgba(30, 30, 37, 0.1), 0px 11px 15px rgba(30, 30, 37, 0.1);

  left: calc(100vw - 515px);
  top: calc(100vh - 285px);

  max-width: 500px;
  z-index: 1;

  @media (max-width: $grid-breakpoint-sm) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 25px;
    gap: 20px;
    position: absolute;
    background: #FFFFFF;
    top: calc(100vh - 300px);
    left: 3px;
    margin: 0 10px;
    width: calc(100% - 20px);
    z-index: 1;
  }

  @media (max-height: 500px) {
    left: calc(100vw - 505px);
  }
}

.expanded {
  top: calc(100vh - 660px);

  @media (max-width: $grid-breakpoint-sm) {
    top: calc(100vh - 685px);
  }

  @media(max-height: 500px) {
    top: calc(100vh - 395px);
  }
}

.feedback-card-title {
  display: grid;
  width: 100%;
  grid-template-columns: 98% 2%;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.feedback-title {
  color: black;
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 24px;
}

.feedback-header {
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 16px;
}

.feedback-card-button-grid {
  display: grid;
  grid-template-columns: 35% 35% 30%;
  padding-bottom: 20px;
  gap: 0;
  width: 100%;

  @media (max-width: $grid-breakpoint-sm) {
    grid-template-columns: 38% 38% 24%;
  }
}

.hidden {
  display: none;
}

.feedback-expanded-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.feedback-bottom-text {
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  margin-top: -10px;
}

.expanded-feedback {
  resize: vertical;
  border-radius: 15px;
  max-height: 380px;
  min-height: 80px;
  width: 435px;
  padding: 10px;

  @media (max-width: $grid-breakpoint-sm) {
    width: 100%;
  }
}

.character-count {
  padding-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Poppins';
  color: #737678;
}

.consent-checkbox {
  padding-bottom: 15px;
  margin-left: -4px;
  font-weight: normal;
  cursor: pointer;
}

.send-feedback-button {
  width: 50%;
  float: right;
  margin-bottom: 0;

  @media (max-width: $grid-breakpoint-sm) {
    width: 100%;
  }
}

.closeBtn {
  border: 0;
  background: none;
  position: absolute;
  right: 10px;
  font-size: 20px;
}

.feedback-button {
  cursor: pointer;
  border: none;
  background: none;
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
}

.feedback-button:disabled {
  cursor: not-allowed;
}
</style>
